import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import Icon from "../../../Icon";
import style from "./style.module.scss";
export function SelectListOption({ option, selected, multiple, hideIcon }) {
    return (_jsx("div", { role: "menuitem", className: classNames(style["select-list-option"], {
            [style["select-list-option--selected"]]: selected,
        }), children: _jsxs("label", { className: classNames(style["select-list-option__label"], "qa-select-list-option__label"), children: [hideIcon !== true && (_jsx("div", { className: multiple ? style["select-list-option__checkbox"] : style["select-list-option__radio"], children: selected && multiple ? _jsx(Icon, { name: "check" }) : null })), option.label, selected] }) }));
}
